module.exports = __webpack_public_path__ + "static/media/Malerpalette_mit_2_Pinseln.200a1812.gif";